import { render, staticRenderFns } from "./SumaryBankRelationshipGroup.vue?vue&type=template&id=f998360e&"
import script from "./SumaryBankRelationshipGroup.vue?vue&type=script&lang=js&"
export * from "./SumaryBankRelationshipGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports